module.exports = __webpack_public_path__ + "static/media/medical-quote.77cab24f.svg";